import Styled from "styled-components";

export const Stored = Styled.nav`
position: absolute;
width: 100%;
height: 100%;
z-index: 1032;
background-color: white;
animation: fadeInRight .8s ease-in-out;

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(50rem);
  }
  to {
    opacity: 1;
  }
}
`;

export const ContainerBar = Styled.div`
text-align: center;
 
.alignment{
 display: flex;
 border-radius: 8px;
 padding: 10px 0;
 margin-bottom: 30px;
 
 svg{
    margin-right: 30px;
    width: 25px;
    height: 25px;
  }
}
`;

export const Category = Styled.p`
  font-size: 24px;
  font-weight: 700;
`;

export const SearchBar = Styled.input`

    width: 100%;
    text-align: center;
    outline: none;
    border: 0;

    ::Placeholder{
      padding-left: 60px;
    }

`;

export const ContainerContent = Styled.ul`
padding-left: 0;
svg{
}
.title{
  font-weight: bold !important;
  font-size: 1.2rem !important;
  list-style-type: none;
  font-family: var(--font-family);
}

.typography{
  margin-top: 0px !important;
  cursor:pointer;
  padding: 0 40px; 
  display: flex;
  padding: 10px 0;
}

.typography a {
  text-decoration: none;
}

.typography .sub-item {
    font-size: 1rem !important;
}
`;

export const BoxCategories = Styled.div`
  padding-bottom: 100px;

  li {
    list-style-type: none;
    height: 47px;
  }
  .list-content {
    display: flex;
    align-items: center;
  }
`;
export const TitleProduct = Styled.p`
 margin-top: 10px;
 font-weight: bold;
 margin-top: 50px;
`;

export const MenuWrap = Styled.div`
  @media (min-width: 1024px) {
    .container {
      max-width: 720px;
    }
  }
`;
